export default __webpack_public_path__ + "static/media/restaurant.798c8f11.png";